import JumboClient from 'jumbo-client-js/dist/jumbo';
import { BuildCorporateDashboardTracking } from './Builder';

const jumboClient = JumboClient.getInstance();
const jumboClientHeaders = jumboClient.getPacketHeader;

const JUMBO_TABLES = {
  ZFE_CORPORATE_DASHBOARD_TRACKING: 'zfe_corporate_dashboard_tracking',
};

const SOURCE = 'web2';

const setParams = (user_id = 0) => {
  jumboClient.setParams(user_id);
};
/*
  Overriding the getPacketHeader method from Jumbo Client library
  to add additional params required to be sent in header object
  present in jumbo event object.
*/
const setHeaders = () => {
  jumboClient.getPacketHeader = () => {
    const jumboHeaders = jumboClientHeaders();
    return {
      ...jumboHeaders,
      app_type: SOURCE,
    };
  };
};

export const sendEventToJumbo = (tableKey, payloadToPost) => {
  jumboClient.sendToJumbo(tableKey, payloadToPost);
};

export const sendTrackingEventsToJumbo = (eventType, payload = {}) => {
  try {
    sendEventToJumbo(
      JUMBO_TABLES.ZFE_CORPORATE_DASHBOARD_TRACKING,
      BuildCorporateDashboardTracking({
        url_segment: window.location.href,
        event_type: eventType,
        ...payload,
      }),
    );
  } catch (err) {
    console.log('Error in sending event to Jumbo', err);
  }
};

export default {
  setParams,
  setHeaders,
};
